export function formatColumnName(column: string): string {
  if (column === 'inviteSent') return 'Invite Sent';
  if (column === 'registeredAt') return 'Account Created';
  return column.charAt(0).toUpperCase() + column.slice(1).replace(/([A-Z])/g, ' $1');
}
